/**
 * Privacy Protection Constants
 * 
 * Constants used by the privacy protection system
 */

// App states that trigger privacy blur
export const PRIVACY_TRIGGER_STATES = ['background', 'inactive'];

// App states that hide privacy blur
export const PRIVACY_HIDE_STATES = ['active'];

// Blur intensity for the privacy overlay
export const PRIVACY_BLUR_INTENSITY = 100;

// Blur tint for the privacy overlay
export const PRIVACY_BLUR_TINT = 'dark';

// Z-index for privacy overlay (highest priority)
export const PRIVACY_OVERLAY_Z_INDEX = 9999;

// Privacy messages
export const PRIVACY_MESSAGES = {
    DEFAULT: 'Content hidden for privacy',
    TASK_SWITCHER: 'Content hidden in task switcher',
    SCREEN_SHARING: 'Content hidden during screen sharing'
};

// Animation durations (if needed for future enhancements)
export const PRIVACY_ANIMATION_DURATION = 200;

// Service status constants
export const PRIVACY_SERVICE_STATUS = {
    UNINITIALIZED: 'uninitialized',
    INITIALIZING: 'initializing',
    INITIALIZED: 'initialized',
    ERROR: 'error'
};
